import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import QuizAnswer from "@jumbo/Dashboards/Tests/QuizAnswer";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.testsPage"} />, link: "/tests" },
  { label: <IntlMessages id={"pages.answerPage"} />, isActive: true },
];

const Answer = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.answerPage" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <QuizAnswer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Answer;
